<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
});


const categories = computed(() => props.data?.categories ?? []);

const chartSeries = computed(() =>
	(props.data?.series ?? []).map((item) => ({
		name: 'Số lượng',
		data: categories.value.map((category, index) => ({
			x: category,
			y: item.data?.[index] ?? 0,
		})),
	}))
);

const chartHeight = computed(() =>
	Math.max(160, categories.value.length * 56)
);

const chartOptions = computed(() => ({
	chart: {
		type: 'bar',
		toolbar: { show: false },
	},
	colors: ['#6366F1'],
	plotOptions: {
		bar: {
			horizontal: true,
			barHeight: '70%',
			distributed: chartSeries.value.length === 1,
		},
	},
	dataLabels: {
		enabled: true,
		style: {
			colors: ['#344256'],
			fontSize: '14px',
			fontWeight: 400,
		},
	},
	legend: {
		show: chartSeries.value.length > 1,
	},
	grid: {
		show: true,
	},
	xaxis: {
		labels: {
			style: {
				colors: '#344256',
				fontSize: '12px',
			},
		},
	},
	yaxis: {
		labels: {
			style: {
				colors: '#344256',
				fontSize: '12px',
			},
		},
	},
}));
</script>

<template>
	<div class="bar-chart w-full">
		<apexchart
			type="bar"
			:height="chartHeight"
			:series="chartSeries"
			:options="chartOptions"
		/>
	</div>
</template>
